import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestApi } from 'app/auth/rest.api';
import { ApiKeyData, IApiKeyResponse, CurrentEnvironmentResponse } from '../models/api-key';

@Injectable()
export class ApiKeyService {
    private apiKeyUrl = 'api/ApiKey';

    constructor(private _authHttp: RestApi) { }

    getApiKeyConfigurationStatus(): Observable<ApiKeyData> {
        return this._authHttp.get(`${this.apiKeyUrl}/GetApiKeyData`);
    }

    generateApiKey(configuration: ApiKeyData): Observable<IApiKeyResponse> {
        return this._authHttp.post(`${this.apiKeyUrl}/GenerateNewApiKey`, configuration).pipe(
            map((response: string | IApiKeyResponse) => {
                if (typeof response === 'string') {
                    return { ApiKey: response };
                }
        
                return response;
            })
        );
    }

    saveApiKeyConfiguration(configuration: ApiKeyData): Observable<any> {
        return this._authHttp.post(`${this.apiKeyUrl}/SaveApiKeyData`, configuration);
    }

    getCurrentEnvironment(): Observable<string> {
        return this._authHttp.get('api/Environment/GetCurrentEnvironment').pipe(
            map((response: string | CurrentEnvironmentResponse) => {
                if (typeof response === 'string') {
                    const trimmedResponse = response.trim();

                    if (trimmedResponse.startsWith('{') && trimmedResponse.endsWith('}')) {
                        try {
                            const parsedResponse = JSON.parse(trimmedResponse) as CurrentEnvironmentResponse;
                            return parsedResponse.Current || '';
                        } catch {
                            return response;
                        }
                    }

                    return response;
                }

                return response.Current || '';
            })
        );
    }
}
